import { Category } from "@/shared/utils/interfaces";
import ColorPerTarget from "../ColorPerTarget";

interface TargetValuesProps {
  category: Category;
}

const CategoryModalAdvance = ({ category }: TargetValuesProps) => {
  return (
    <div className="my-20 flex flex-wrap gap-4">
      <ColorPerTarget data={category} />
    </div>
  );
};

export default CategoryModalAdvance;
